<template>
  <div class="rating" :class="type">
    <div
      v-show="type === 'detailed-horizontal' || type === 'detailed-vertical'"
      class="rating-count"
      :class="type === 'detailed-vertical' ? 'display-xl' : 'headline-l'"
    >
      {{ ratingCount }}
    </div>
    <div class="stars">
      <div class="star-icon-base-container">
        <UiIcon
          v-for="index in MAX_RATING_COUNT_ARRAY"
          :key="index"
          class="star-icon-base"
          name="star-filled"
          size="16px"
          color-fill="var(--color-base-grey-10)"
        />
        <div
          class="star-icon-filled-container"
          :style="{ width: `${highlightedPercentage()}%` }"
        >
          <div class="star-icon-filled-inner-container">
            <UiIcon
              v-for="index in MAX_RATING_COUNT_ARRAY"
              :key="index"
              class="star-icon-filled"
              name="star-filled"
              size="16px"
              color-fill="var(--color-brand-primary-base)"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-show="type !== 'simplified'" class="review-text">
      {{ reviewText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'
import type { Type } from './IType'

const MAX_RATING_COUNT = 5
const MAX_RATING_COUNT_ARRAY = Array.from(Array(MAX_RATING_COUNT).keys())

interface Props {
  ratingCount: number
  reviewText?: string
  type: Type
}

const props = withDefaults(defineProps<Props>(), {
  ratingCount: 0,
  reviewText: '',
})

function highlightedPercentage(): number {
  return (props.ratingCount / MAX_RATING_COUNT) * 100
}
</script>

<style lang="scss" scoped>
.rating {
  align-items: center;
  column-gap: 5px;
  display: flex;
  flex-direction: row;

  .rating-count.headline-l {
    margin-bottom: -3px;
  }

  .review-text {
    text-decoration: underline;
  }

  .star-icon-base-container {
    display: flex;
  }

  .star-icon-filled-container {
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;

    .star-icon-filled-inner-container {
      display: flex;
    }
  }

  .stars {
    position: relative;
  }

  &.default {
    .review-text,
    .stars {
      text-decoration: unset;
    }
  }

  &.detailed-vertical {
    flex-direction: column;
    row-gap: 5px;
    text-align: center;
  }
}
</style>
